/**
 * Shopify AJAX Predictive Search Controller
 */

function initPredictiveSearchPopup() {
  const popup = document.querySelector('.predictive-search-popup');
  if (!popup) return;

  const searchInput = popup.querySelector('.js-search-input');
  const resultsContainer = popup.querySelector('.js-search-results-container');
  const searchCard = popup.querySelector('.predictive-search-card');
  
  const defaultState = popup.querySelector('.js-search-default-state');
  const liveState = popup.querySelector('.js-search-live-state');
  const loadingState = popup.querySelector('.js-search-loading');

  const suggestionsList = popup.querySelector('.js-results-suggestions');
  const productsList = popup.querySelector('.js-results-products');
  const categoriesList = popup.querySelector('.js-results-categories');

  const viewAllLink = popup.querySelector('.js-view-all-link');
  const searchTermText = popup.querySelector('.js-search-term-text');

  const currencySymbol = popup.dataset.currencySymbol || '$';
  const moneyFormat = popup.dataset.moneyFormat || '${{amount}}';

  let debounceTimer;

  // Dynamically position the search popup right below the active header
  function updatePopupPosition() {
    // Queries the custom header dynamically in case of deferred load race conditions
    const headerElement = document.getElementById('CustomHeader') || 
                          document.querySelector('.custom-header-wrapper') ||
                          document.querySelector('header');

    if (!headerElement) {
      popup.style.top = '122px';
      popup.style.height = 'calc(100vh - 122px)';
      return;
    }
    const headerRect = headerElement.getBoundingClientRect();
    const headerBottom = Math.max(0, headerRect.bottom);
    
    popup.style.top = `${headerBottom}px`;
    popup.style.height = `calc(100vh - ${headerBottom}px)`;
  }

  // Formatting Helper for Shopify Prices
  function formatPrice(priceString) {
    const price = parseFloat(priceString);
    if (isNaN(price)) return '';
    
    if (moneyFormat) {
      let formatted = moneyFormat;
      if (formatted.includes('{{amount}}')) {
        formatted = formatted.replace('{{amount}}', price.toFixed(2));
      }
      if (formatted.includes('{{amount_no_decimals}}')) {
        formatted = formatted.replace('{{amount_no_decimals}}', Math.round(price).toString());
      }
      if (formatted.includes('{{amount_with_comma_separator}}')) {
        formatted = formatted.replace('{{amount_with_comma_separator}}', price.toFixed(2).replace('.', ','));
      }
      return formatted;
    }
    return `${currencySymbol}${price.toFixed(2)}`;
  }

  // Open Search Popup
  function openSearch() {
    updatePopupPosition(); 
    popup.classList.add('is-active');
    document.body.classList.add('search-popup-open');
    setTimeout(() => searchInput.focus(), 150);
  }

  // Close Search Popup
  function closeSearch() {
    popup.classList.remove('is-active');
    document.body.classList.remove('search-popup-open');
    searchInput.value = '';
    showDefaultState();
  }

  // Set States
  function showDefaultState() {
    defaultState.style.display = 'block';
    liveState.style.display = 'none';
    loadingState.style.display = 'none';
  }

  function showLoadingState() {
    defaultState.style.display = 'none';
    liveState.style.display = 'none';
    loadingState.style.display = 'block';
  }

  function showResultsState() {
    defaultState.style.display = 'none';
    liveState.style.display = 'block';
    loadingState.style.display = 'none';
  }

  // Fetch Results from Shopify Predictive Search API
  function fetchSearchResults(query) {
    if (!query) {
      showDefaultState();
      return;
    }

    showLoadingState();

    const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,collection,query&resources[limit]=5&resources[options][unavailable_products]=last`;

    fetch(url)
      .then(response => {
        if (!response.ok) throw new Error('API Error');
        return response.json();
      })
      .then(data => {
        renderResults(data, query);
      })
      .catch(error => {
        console.error('Predictive Search failed:', error);
        showDefaultState();
      });
  }

  // Render Results HTML Dynamic
  function renderResults(data, query) {
    const results = data.resources.results;

    suggestionsList.innerHTML = '';
    productsList.innerHTML = '';
    categoriesList.innerHTML = '';

    const hasQueries = results.queries && results.queries.length > 0;
    const hasProducts = results.products && results.products.length > 0;
    const hasCollections = results.collections && results.collections.length > 0;

    // Column 1: Suggestions
    if (hasQueries) {
      popup.querySelector('.js-results-suggestions-col').style.display = 'block';
      results.queries.forEach(item => {
        const li = document.createElement('li');
        const text = item.styled_text ? item.styled_text : item.text;
        li.innerHTML = `
          <a href="${item.url}">
            <span class="suggestion-icon-bullet">🔍</span>
            <span class="suggestion-text">${text}</span>
          </a>
        `;
        suggestionsList.appendChild(li);
      });
    } else {
      popup.querySelector('.js-results-suggestions-col').style.display = 'none';
    }

    // Column 2: Products
    if (hasProducts) {
      popup.querySelector('.js-results-products-col').style.display = 'block';
      results.products.forEach(item => {
        const itemHtml = document.createElement('a');
        itemHtml.href = item.url;
        itemHtml.className = 'predictive-search-product-item';
        
        const priceHtml = formatPrice(item.price);
        const imgUrl = item.image ? item.image : 'https://cdn.shopify.com/s/images/themes/product-1.png';

        itemHtml.innerHTML = `
          <img class="predictive-search-product-image" src="${imgUrl}" alt="${item.title}" loading="lazy">
          <div class="predictive-search-product-info">
            <span class="product-title">${item.title}</span>
            <span class="product-price">${priceHtml}</span>
          </div>
        `;
        productsList.appendChild(itemHtml);
      });
    } else {
      popup.querySelector('.js-results-products-col').style.display = 'none';
    }

    // Column 3: Categories (Collections)
    if (hasCollections) {
      popup.querySelector('.js-results-categories-col').style.display = 'block';
      results.collections.forEach(item => {
        const li = document.createElement('li');
        li.innerHTML = `
          <a href="${item.url}">
            <span class="category-text">${item.title}</span>
          </a>
        `;
        categoriesList.appendChild(li);
      });
    } else {
      popup.querySelector('.js-results-categories-col').style.display = 'none';
    }

    if (hasQueries || hasProducts || hasCollections) {
      viewAllLink.href = `/search?q=${encodeURIComponent(query)}`;
      searchTermText.textContent = query;
      showResultsState();
    } else {
      showDefaultState();
    }
  }

  // Event Listeners
  searchInput.addEventListener('input', (e) => {
    const query = e.target.value.trim();
    
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      fetchSearchResults(query);
    }, 200); 
  });

  // Open Triggers
  document.querySelectorAll('.js-open-predictive-search').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      openSearch();
    });
  });

  // Close Triggers (X button inside input)
  popup.querySelectorAll('.predictive-search-close-btn').forEach(el => {
    el.addEventListener('click', closeSearch);
  });

  // Close on Escape Key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && popup.classList.contains('is-active')) {
      closeSearch();
    }
  });

  // CHANGED: Document-level click listener to safely close search when clicking outside
  document.addEventListener('click', (event) => {
    if (!popup.classList.contains('is-active')) return;
    
    const isClickInsideCard = searchCard.contains(event.target);
    const isClickOnOpenButton = event.target.closest('.js-open-predictive-search');
    const isClickOnInput = event.target === searchInput;

    if (!isClickInsideCard && !isClickOnOpenButton && !isClickOnInput) {
      closeSearch();
    }
  });

  // Keep search box aligned with header bottom on scroll or resize
  window.addEventListener('resize', () => {
    if (popup.classList.contains('is-active')) updatePopupPosition();
  });
  window.addEventListener('scroll', () => {
    if (popup.classList.contains('is-active')) updatePopupPosition();
  }, { passive: true });

  // Expose triggers globally
  window.openPredictiveSearchPopup = openSearch;
  window.closePredictiveSearchPopup = closeSearch;
}

// Initialize on DOM Load
document.addEventListener('DOMContentLoaded', initPredictiveSearchPopup);

// Initialize when customized in Shopify Editor
document.addEventListener('shopify:section:load', initPredictiveSearchPopup);